"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var am4core = _interopRequireWildcard(require("@amcharts/amcharts4/core"));

var _minusSolidWhiteDataUrl = _interopRequireDefault(require("../../icons/minusSolidWhiteDataUrl"));

var _button = _interopRequireDefault(require("./button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var amChartZoomOutButton = function amChartZoomOutButton(zoomOutButton) {
  var create = function create(id) {
    var amButton = (0, _button["default"])().create(id);
    return amButton;
  };

  var setDefaultStyles = function setDefaultStyles(theme) {
    (0, _button["default"])(zoomOutButton).setDefaultStyles(theme);
    zoomOutButton.background.cornerRadius(am4core.percent(100), am4core.percent(100), am4core.percent(100), am4core.percent(100));
    zoomOutButton.width = 32;
    zoomOutButton.height = 32;
    zoomOutButton.paddingLeft = 0;
    zoomOutButton.paddingRight = 0;
    var zoomOutButtonImage = zoomOutButton.createChild(am4core.Image);
    zoomOutButtonImage.href = _minusSolidWhiteDataUrl["default"];
    zoomOutButtonImage.width = 16;
    zoomOutButtonImage.height = 16;
    zoomOutButtonImage.align = 'center';
    zoomOutButtonImage.valign = 'middle';
    zoomOutButtonImage.horizontalCenter = 'middle';
    zoomOutButtonImage.verticalCenter = 'middle';
    zoomOutButton.icon = zoomOutButtonImage;
    return zoomOutButton;
  };

  return {
    create: create,
    setDefaultStyles: setDefaultStyles
  };
};

var _default = amChartZoomOutButton;
exports["default"] = _default;